import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Link } from 'transfix-ui/core'
import { generateBaseUrl } from 'utils/generateAppDefaults'
import { useShipperAutoAcceptRejectResultQuery } from '../graphql/ShipperAutoAcceptRejectResult'

interface IAutoAcceptRejectDetailsCardProps {
  shipmentId: string
  shipperId: number
}

interface IRuleApplied {
  result: boolean
  ruleId: number
  message?: string
}

function parseDecision(decision: string, isFinal: boolean | undefined | null) {
  const words = decision.split('_')
  const output: string[] = []

  if (isFinal === true) {
    output.push('Final AAR Decision:')
  } else {
    output.push('Estimated AAR Decision:')
  }

  for (const word of words) {
    output.push(word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase())
  }
  return output.join(' ')
}

export const AutoAcceptRejectDetailsCard: FC<IAutoAcceptRejectDetailsCardProps> = ({
  shipmentId,
  shipperId,
}) => {
  const { data } = useShipperAutoAcceptRejectResultQuery({
    variables: {
      shipmentId,
    },
  })
  const aarPage = generateBaseUrl(`shippers/${shipperId}/operations`)
  const messages: string[] = []
  if (data?.shipperAutoAcceptRejectResult?.rulesApplied != null) {
    data.shipperAutoAcceptRejectResult.rulesApplied.forEach((x: IRuleApplied) => {
      if (x.message != null) {
        messages.push(x.message)
      }
    })
  }

  return (
    <Card collapsible transparent mini title='Auto Accept Reject Rules'>
      <Box>
        {data?.shipperAutoAcceptRejectResult == null || data == null ? (
          <Link href={aarPage} data-test='not-configured-link'>
            Auto-accept-reject is not configured for this shipment. Configuration can be added or
            modified here.
          </Link>
        ) : (
          <Box data-test='configured-text'>
            {parseDecision(
              String(data.shipperAutoAcceptRejectResult.decision),
              data.shipperAutoAcceptRejectResult.isFinal
            )}
          </Box>
        )}
      </Box>
      {messages &&
        messages.map(message => {
          return <Box>{message}</Box>
        })}
    </Card>
  )
}
